import { useState } from 'react';
import PropTypes from 'prop-types';

import { Document, Page, pdfjs } from 'react-pdf';

import Fab from '@mui/material/Fab';
import Typography from '@mui/material/Typography';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

import Loading from 'uI/Loading/Loading';
import classes from './PreviewPDF.module.css';

const PreviewPDF = props => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [maxScale] = useState(1.7);
  const [minScale] = useState(0.3);
  const [numPages, setNumPages] = useState(0);
  const [pageNumber] = useState(1);
  const [scale, setScale] = useState(1.1);
  const scaleStep = 0.1;

  const onDocumentLoadSuccess = document => {
    const { numPages } = document;
    setNumPages(numPages);
  };

  const handleZoomOut = () => {
    setScale(scale - scaleStep);
  };

  const handleZoomIn = () => {
    setScale(scale + scaleStep);
  };

  return (
    <center>
      <div className={classes.containerPDF}>
        <Document
          file={props.urlDegree}
          onLoadSuccess={onDocumentLoadSuccess}
          maxScale={maxScale}
          minScale={minScale}
          error={
            <Typography className={classes.textPDFLoading}>
              Error
            </Typography>
          }
          loading={<Loading />}
          noData={
            <Typography className={classes.textPDFLoading}>
              No Diploma
            </Typography>
          }
        >
          {numPages >= 10 ? (
            <Page
              pageNumber={pageNumber}
              className={classes.pagePDF}
              scale={scale}
            />
          ) : (
            <div>
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  className={classes.pagePDF}
                  scale={scale}
                />
              ))}
            </div>
          )}
          <div className={classes.containerFab}>
            <div className={classes.contentFab}>
              <Fab
                className={classes.fabsIcon}
                onClick={handleZoomOut}
                disabled={scale.toFixed(2) == minScale}
              >
                <ZoomOutIcon className={classes.iconNavigation} />
              </Fab>
              <Fab
                className={classes.fabsIcon}
                onClick={handleZoomIn}
                disabled={scale.toFixed(2) == maxScale}
              >
                <ZoomInIcon className={classes.iconNavigation} />
              </Fab>
            </div>
          </div>
        </Document>
      </div>
    </center>
  );
};

PreviewPDF.propTypes = {
  // eslint-disable-next-line react/require-default-props
  urlDegree: PropTypes.string
};

export default PreviewPDF;
